export const eLetterParamsCB: (Submodule: any) => string[] = submodule => {
  let eLetterParamsArray: string[] = []

  // Common CB Header-Level Parameters
  const commonHeaderParams: string[] = [
    '[CompanyBankAccCode]',
    '[CompanyBankAccNo]',
    '[CompanyBankName]',
    '[ChequeNo]',
    '[Description]',
    '[DocumentNo]',
    '[DocumentDate]',
    '[TransactionDate]',
    '[ReferenceNo]',
    '[PaymentMethod]',
  ]

  // Common CB Item-Level Parameters
  const commonItemLevelParams: string[] = [
    '[Index]',
    '[ItemDocDate]',
    '[ItemRemark]',
    '[ItemAccCode]',
    '[ItemAccDesc]',
    '[ItemDeptCode]',
    '[ItemDeptName]',
    '[ItemTaxRate]',
    '[ItemBaseAmt]',
    '[ItemTaxAmt]',
    '[ItemTotalAmt]',
  ]

  const commonSummaryParams: string[] = ['[SumTotalAmt]', '[SumTotalAmtWord]']

  switch (submodule) {
    case 'PAYMENT':
      return (eLetterParamsArray = [
        ...commonHeaderParams,
        '[PayeeName]',
        ...commonItemLevelParams,
        ...commonSummaryParams,
      ])

    case 'RECEIPT':
      return (eLetterParamsArray = [
        ...commonHeaderParams,
        '[ReceivedFrom]',
        ...commonItemLevelParams,
        ...commonSummaryParams,
      ])

    case 'BANK_TRANSFER':
      return (eLetterParamsArray = [
        '[DocumentNo]',
        '[DocumentDate]',
        '[TransferDate]',
        '[TransactionDate]',
        '[ReferenceNo]',
        '[ToBankAcc]',
        '[FromBankAcc]',
        '[ToBankAccNo]',
        '[FromBankAccNo]',
        '[PaymentMethod]',
        '[ChequeNo]',
        '[Description]',
        '[FromBankCode]',
        '[ToBankCode]',
        '[TotalAmt]',
        '[TotalAmtWord]',
      ])
  }
}
